

export const trackEvent = (eventName: string, eventLabel: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "customClickEvent",
        eventName,
        eventLabel,
    });
};